export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de dirección"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de cuenta"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moneda"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear dirección"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear cuenta"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creación de nueva dirección"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear nueva cuenta"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese el nombre"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccione la moneda"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccione el tipo"])}
}